import React from "react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {IHistoryRecordViewModel} from "../../../../services/gaming-history/models/record/history-record-view-model.interface";
import {HistoryRecordContentBox} from "./boxes/history-record-content.box";
import {GamingHistoryRecordContentStartSectionComponent} from "./gaming-history-record-content-start-section.component";
import {GamingHistoryRecordContentMiddleSectionComponent} from "./gaming-history-record-content-middle-section.component";
import {GamingHistoryRecordContentEndSectionComponent} from "./gaming-history-record-content-end-section.component";
import {observer} from "mobx-react";


interface GamingHistoryRecordContentComponentProps {
    record: IHistoryRecordViewModel;
    showMoreDetails: boolean;
}

export const GamingHistoryRecordContentComponent = observer(
    class GamingHistoryRecordContentComponent extends OrbitComponent<GamingHistoryRecordContentComponentProps> {

        private _renderMiddleSection() {
            if(this.services.mediaQuery.sAndBelow) {
                return null;
            }

            return (<GamingHistoryRecordContentMiddleSectionComponent record={this.props.record}/>);
        }

        render() {
            return (
                <HistoryRecordContentBox>
                    <GamingHistoryRecordContentStartSectionComponent record={this.props.record}/>

                    {this._renderMiddleSection()}

                    <GamingHistoryRecordContentEndSectionComponent record={this.props.record} showMoreDetails={this.props.showMoreDetails}/>
                </HistoryRecordContentBox>
            );
        }
    }
);